<template>
  <el-dialog
    title="编辑"
    :close-on-click-modal="false"
    :visible.sync="dialogVisible"
    :before-close="handleClose"
    width="800px"
    class="correct-dialog"
  >
    <el-radio-group v-model="editForm.type" @change="handleAim">
      <el-radio :label="1">意图审核</el-radio>
      <el-radio :label="2">新增意图</el-radio>
    </el-radio-group>
    <el-form
      status-icon
      label-width="100px"
      v-if="editForm.type == 1"
      label-position="left"
    >
      <el-form-item label="当前意图："
        ><el-input :value="currentItem.intent_name" disabled></el-input
      ></el-form-item>
      <el-form-item label="是否纠正：">
        <el-radio-group v-model="editForm.checked">
          <el-radio :label="1">否</el-radio>
          <el-radio :label="2">是</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="意图纠正：" v-show="editForm.checked == 2">
        <el-autocomplete
          class="inline-input"
          :value="editForm.intent_name"
          @input="onAimInput"
          :fetch-suggestions="querySearchAsync"
          placeholder="请输入后搜索意图"
          @select="handleSelect"
        ></el-autocomplete>
      </el-form-item>
      <el-form-item label="所属类别："
        ><el-input :value="editForm.cate_name" disabled></el-input>
      </el-form-item>
      <el-form-item label="回复内容：">
        <el-input :value="editForm.ans_text" disabled></el-input>
      </el-form-item>
      <el-form-item label="问题标签：">
        <el-select
          v-model="editForm.label_id"
          placeholder="请选择问题标签"
          clearable
        >
          <el-option
            v-for="item in labelLists"
            :key="item.id"
            :value="item.id"
            :label="item.title"
          ></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div v-else>
      <el-form
        :model="confirmArgs"
        status-icon
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="新增类别" prop="cate_name">
          <el-input
            v-model="confirmArgs.cate_name"
            @input="getCateList({ keyword: confirmArgs.cate_name })"
            placeholder="请输入新增类别"
          ></el-input>
        </el-form-item>
        <el-form-item label="新增意图" prop="intent_name">
          <el-input
            v-model="confirmArgs.intent_name"
            @input="getAimList({ keywords: confirmArgs.intent_name })"
            placeholder="请输入新增意图"
          ></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div class="tips">点击提交会自动生成卡片，可前往意图列表编辑回复</div>
    <span slot="footer" class="dialog-footer">
      <el-button size="medium" round @click="handleClose">取消</el-button>
      <el-button size="medium" round type="primary" @click="confirm"
        >提交</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
  import { searchIntent, editDetail, getLabelList } from '@/api/session'
  import { getClassList } from '@/api/aimManager'
  import { isSuccess, isEmpty } from '@/utils/index'

  export default {
    props: {
      dialogVisible: Boolean,
      editForm: Object,
      currentItem: Object,
    },
    data() {
      let validateCate = (rule, value, callback) => {
        if (
          !isEmpty(value) &&
          this.searchCate.filter((item) => item.cate_name == value).length > 0
        ) {
          callback(new Error('类别已存在'))
        }
      }
      let validateIntent = (rule, value, callback) => {
        if (
          !isEmpty(value) &&
          this.aimList.filter((item) => item.intent_name == value).length > 0
        ) {
          callback(new Error('意图已存在'))
        }
      }
      return {
        rules: {
          cate_name: [
            { validator: validateCate, trigger: 'change' },
            { required: true, message: '新增类别必须存在', trigger: 'blur' },
          ],
          intent_name: [
            { validator: validateIntent, trigger: 'change' },
            { required: true, message: '新增意图必须存在', trigger: 'blur' },
          ],
        },
        timeout: null,
        searchCate: [],
        aimList: [],
        confirmArgs: {
          intent_name: '',
          intent_code: '',
        },
        labelLists: [],
      }
    },
    mounted() {
      this.getLabelLists()
    },
    methods: {
      async getCateList(params) {
        const res = await getClassList({ is_all: 1, ...params })
        this.searchCate = res.data.list
      },
      async getLabelLists() {
        const res = await getLabelList({ page: 1, pagesize: 100 })

        this.labelLists = res.data.list
      },
      async getAimList(params) {
        if (params.keywords.length < 1) {
          this.aimList = []
          return
        }
        const res = await searchIntent(params)
        this.aimList = res.data
      },
      handleClose() {
        this.confirmArgs = {
          intent_name: '',
          cate_name: '',
        }
        this.$emit('update:editForm', {
          id: '',
          type: 1,
          intent_name: '',
          cate_name: '',
          ans_text: '',
          checked: 1,
          label_id: '',
        })
        this.$emit('update:dialogVisible', false)
      },
      /**
       * 当切换时
       */
      handleAim(e) {
        if (e == 2) {
          this.confirmArgs = {
            intent_name: '',
            cate_name: '',
          }
        }
      },
      onAimInput(e) {
        this.$emit('update:editForm', {
          ...this.editForm,
          intent_name: e,
        })
      },
      querySearchAsync(queryString, cb) {
        clearTimeout(this.timeout)
        this.timeout = setTimeout(async () => {
          if (queryString.length < 1) {
            cb([])
            return
          }
          await this.getAimList({ keywords: this.editForm.intent_name })
          let aimList = this.aimList
          let results = queryString
            ? aimList.filter((item) => item.intent_name.includes(queryString))
            : aimList
          results = results.map((item) => {
            return { ...item, value: item.intent_name }
          })
          // 调用 callback 返回建议列表的数据
          cb(results)
        }, 500 * Math.random())
      },
      handleSelect(item) {
        this.$emit('update:editForm', {
          ...this.editForm,
          intent_name: item.intent_name,
          cate_name: item.cate_name,
          ans_text: item.ans_text,
        })
        this.confirmArgs = item
      },
      async confirm() {
        let form = { type: this.editForm.type, id: this.editForm.id }
        if (this.editForm.type == 1) {
          let cate_code = this.confirmArgs.cate_code
          let intent_code = this.confirmArgs.intent_code
          let ans_code = this.confirmArgs.ans_code
          if (this.editForm.checked == 1) {
            cate_code = this.currentItem.cate_code
            intent_code = this.currentItem.intent_code
            ans_code = this.currentItem.ans_code
          }
          form = {
            ...form,
            cate_code,
            intent_code,
            ans_code,
            checked: this.editForm.checked,
            label_id: this.editForm.label_id,
          }
          if (isEmpty(form.intent_code)) {
            this.$message.error('请选择搜索到的意图')
            return
          }
        } else {
          form = {
            ...form,
            cate_name: this.confirmArgs.cate_name,
            intent_name: this.confirmArgs.intent_name,
          }
        }
        const res = await editDetail(form)
        if (isSuccess(res.code)) {
          this.$message.success('修改成功')
          this.handleClose()
          this.$emit('getList')
        }
      },
    },
  }
</script>

<style lang="scss">
  .correct-dialog {
    .el-radio-group {
      margin-bottom: 20px;
    }
    .el-radio__label {
      //   margin-bottom: 20px;
      font-size: 16px;
      color: #333;
    }
    .el-autocomplete {
      width: 100%;
    }
    .el-form-item__content {
      .el-radio-group {
        margin-bottom: 0;
      }
    }
  }
</style>
